export default __webpack_public_path__ + "static/media/COA-background.5344c6be.png";